const host = window.location.hostname;
const localDevelopment = host.indexOf('localhost') !== -1;

let whichEnv = 'prod';
if (host.indexOf('.dev.') !== -1) {
  // look for dash because we might have qa41 sometime
  const dash = host.indexOf('-');
  const dotDev = host.indexOf('.dev.');
  whichEnv = host.substring(dash + 1, dotDev);
}

if (localDevelopment) {
  // set this in .env.development if you want to point to a particular env
  if (process.env.REACT_APP_DEV_ENVIRONMENT) {
    whichEnv = process.env.REACT_APP_DEV_ENVIRONMENT;
  } else {
    whichEnv = 'dev';
  }
}

const isProd = whichEnv === 'prod';
const domainQualifier = isProd ? '' : '-' + whichEnv + '.dev';
const eveDomainQualifier = isProd ? '' : '-qa1.dev';
const viperDomainQualifier = isProd ? '' : whichEnv;

// const qaAmplitudeKey = 'fc3641eafde1f669e596acda245157ec';
// export const amplitudeApiKeys = {
//   dev: qaAmplitudeKey,
//   qa1: qaAmplitudeKey,
//   qa2: qaAmplitudeKey,
//   qa3: qaAmplitudeKey,
//   qa4: qaAmplitudeKey,
//   prod: '516a3b34f0c569d87cb7a1e5da7de063'
// };

const qaEngagementKey = 'a6500576-763f-4b08-804f-9c1a1d7f9031';
const prodEngagementKey = 'c60008bd-a2fe-439c-a56f-e1dc03c2d78a';

// admin tools changes its name depending
let rsmUrl;
if (localDevelopment) {
  rsmUrl = 'http://localhost:4022/#/login';
} else if (isProd) {
  rsmUrl = 'https://administratortools.rosettastone.com/#/login';
} else {
  rsmUrl = 'https://admin' + domainQualifier + '.rosettastone.com';
}

let egoHost = 'https://ego' + domainQualifier + '.rosettastone.com';
if (process.env.REACT_APP_USE_LOCAL_EGO) {
  egoHost = 'http://localhost:8087';
  console.log('using local ego');
}

let totaleHost = 'https://totale' + domainQualifier + '.rosettastone.com';
if (process.env.REACT_APP_USE_LOCAL_TOTALE) {
  totaleHost = 'http://localhost:3000';
  console.log('using local totale');
}

let viperHost = viperDomainQualifier + '.rosettastoneenterprise.com';
if (process.env.REACT_APP_USE_LOCAL_VIPER) {
  viperHost = 'http://localhost:3000';
  console.log('using local viper service');
}

let prismHost = 'https://prism' + domainQualifier + '.rosettastone.com';
if (process.env.REACT_APP_USE_LOCAL_PRISM) {
  prismHost = 'http://localhost:8103';
  console.log('using local prism');
}

let emailHost = 'https://email' + domainQualifier + '.rosettastone.com';
if (process.env.REACT_APP_USE_LOCAL_EMAIL) {
  emailHost = 'http://localhost:3000';
  console.log('using local email');
}
let lpsHost = 'https://launchpad-service' + domainQualifier + '.rosettastone.com';
if (process.env.REACT_APP_USE_LOCAL_LPS) {
  lpsHost = 'http://localhost:3000';
  console.log('using local lps');
}
let sirenHost = 'https://siren' + domainQualifier + '.rosettastone.com';
if (process.env.REACT_APP_USE_LOCAL_SIREN) {
  sirenHost = 'http://localhost:8083';
  console.log('using local siren');
}
let tullyHost = 'https://tully' + domainQualifier + '.rosettastone.com';
if (process.env.REACT_APP_USE_LOCAL_TULLY) {
  tullyHost = 'http://localhost:8085';
  console.log('using local tully');
}

let learnerNarwhalApiHost = isProd
  ? 'https://api.rosettastone.com'
  : whichEnv === 'qa3'
  ? 'https://api--sng-rsln-dev.dev.rosettastone.com'
  : 'https://api--rc-snap-a.dev.rosettastone.com';
if (process.env.REACT_APP_USE_LOCAL_LEARNER_NARWHAL) {
  learnerNarwhalApiHost = 'http://localhost:8080';
  console.log('using local learner narwhal api');
}

let learnerNarwhalHost = isProd
  ? 'https://rsln-web.rosettastone.com'
  : whichEnv === 'qa3'
  ? 'https://www--sng-rsln-dev.dev.rosettastone.com'
  : 'https://www--rc-snap-a.dev.rosettastone.com';
if (process.env.REACT_APP_USE_LOCAL_LEARNER_NARWHAL) {
  learnerNarwhalHost = 'http://localhost:3000';
  console.log('using local learner narwhal');
}

export const envConfigs = {
  engagementApiKey: whichEnv === 'prod' ? prodEngagementKey : qaEngagementKey,
  dev: localDevelopment,
  egoApiHost: egoHost,
  totaleApiHost: totaleHost,
  viperApiHost: viperHost,
  eveHost: 'https://eve' + eveDomainQualifier + '.rosettastone.com',
  prismApiHost: prismHost,
  emailApiHost: emailHost,
  gaiaUri: localDevelopment ? 'http://localhost:4024/' : 'https://learn' + domainQualifier + '.rosettastone.com/',
  lpsApiHost: lpsHost,
  learnerNarwhalApiHost: learnerNarwhalApiHost,
  learnerNarwhalHost: learnerNarwhalHost,
  placementTestEnabled: 'true',
  placementTestHost: 'http://rosetta.thetestfactory.com',
  rsmUri: rsmUrl,
  sirenApiHost: sirenHost,
  totaleUri: 'https://totale.rosettastone.com/titan_authentication',
  tullyApiHost: tullyHost,
  appName: 'Launchpad',
  env: whichEnv
};



// WEBPACK FOOTER //
// ./src/envConfigs.js